import React, { useEffect, useState } from "react";
import ScaleLoader from "react-spinners/ScaleLoader";
import { Gear, Warning } from "phosphor-react";
import { Box } from "@material-ui/core";
import LoaderSvg from "../Svg/LoaderSvg";

export default function CustomLoader({ type, customLoaderText }) {
  const loaderData = [
    {
      firstMessage: (
        <span>
          Feeling too <span style={{ color: "#6C65D9" }}>overwhelmed</span> by
          in-app and email notifications?
        </span>
      ),
      secondMessage: (
        <span>
          You can choose which notifications to receive in{" "}
          <Gear color="#6C65D9" />
          <span style={{ color: "#6C65D9" }}>Project Settings</span>.
        </span>
      ),
    },
    {
      firstMessage: (
        <span>
          You’ve been working for quite some time now.{" "}
          <span style={{ color: "#6C65D9" }}>Take a small break!</span>
        </span>
      ),
      secondMessage: (
        <span>
          Taking small breaks helps{" "}
          <span style={{ color: "#6C65D9" }}>revitalize</span> the mind and can
          boost <span style={{ color: "#6C65D9" }}>productivity</span>.
        </span>
      ),
    },
    {
      firstMessage: (
        <span>
          Found an Issue? Go ahead and report the issue at our{" "}
          <Warning color="#6C65D9" />{" "}
          <span style={{ color: "#6C65D9" }}>Report Center</span>
        </span>
      ),
      secondMessage: (
        <span>
          We take <span style={{ color: "#6C65D9" }}>feedback</span> very
          seriously and it would mean a lot!
        </span>
      ),
    },
    {
      firstMessage:
        "“No matter what anybody tells you, words and ideas can change the world.”",
      secondMessage: (
        <span style={{ color: "#6C65D9" }}>~ Dead Poets Society</span>
      ),
    },
    {
      firstMessage:
        "“There should be no boundaries to human endeavor. We are all different. However bad life may seem, there is always something you can do, and succeed at.”",
      secondMessage: (
        <span style={{ color: "#6C65D9" }}>~ The Theory of Everything</span>
      ),
    },
    {
      firstMessage:
        "“You miss 100% of the shots you don't take. -  Wayne Gretzky”",
      secondMessage: <span style={{ color: "#6C65D9" }}>~ Michael Scott</span>,
    },
    {
      firstMessage:
        "“Oh yes, the past can hurt. But, you can either run from it or learn from it.”",
      secondMessage: <span style={{ color: "#6C65D9" }}> ~ The Lion King</span>,
    },
    {
      firstMessage:
        "“If you focus on what you left behind, you will never be able to see what lies ahead.”",
      secondMessage: <span style={{ color: "#6C65D9" }}>~ Ratatouille</span>,
    },
    {
      firstMessage:
        "“No matter what anybody tells you, words and ideas can change the world.”",
      secondMessage: (
        <span style={{ color: "#6C65D9" }}>~ Dead Poets Society</span>
      ),
    },
    {
      firstMessage:
        "“I don't know all the answers, but I know where to find them.”",
      secondMessage: <span style={{ color: "#6C65D9" }}>~ Primer</span>,
    },
    {
      firstMessage:
        "“It's not about how many times you get knocked down, but how many times you get up.”",
      secondMessage: <span style={{ color: "#6C65D9" }}>~ Wreck-It Ralph</span>,
    },
  ];
  const [randomNumber, setRandomNumber] = useState(0);

  useEffect(() => {
    setRandomNumber(Math.floor(Math.random() * loaderData.length));
  }, []);

  return (
    <Box
      style={{
        height: type === "appRegister" ? "100vh" : `calc(100vh - 50%)`,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: type === "appRegister" && "100%",
        position: type === "appRegister" && "absolute",
        zIndex: type === "appRegister" && "1300",
        left: type === "appRegister" && "0",
        top: type === "appRegister" && "0",
        backgroundColor: type === "appRegister" && "#1B1D28",
      }}
    >
      <div
        style={{
          width: "550px",
          height: "300px",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            width: "320px",
            height: "110px",
            left: "180px",
            top: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "space-between",
            paddingBottom: "5px",
          }}
        >
          {!customLoaderText ? (
            <>
              <div style={{ color: "black" }}>
                {loaderData[randomNumber].firstMessage}
              </div>
              <div style={{ color: "black" }}>
                {loaderData[randomNumber].secondMessage}
              </div>
            </>
          ) : (
            <div style={{ color: "black" }}>{customLoaderText}</div>
          )}
        </div>
        <div>
          <LoaderSvg />
        </div>

        <div
          style={{
            height: "400px",
            display: "flex",
            width: "100%",
            position: "absolute",
            left: "310px",
            top: "160px",
          }}
        >
          <ScaleLoader
            color="#6C65D9"
            height={65}
            style={{
              display: "flex",
              verticalAlign: "middle",
            }}
          />
        </div>
      </div>
    </Box>
  );
}
